import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IState } from 'types/Carrier';
import { getClientsThunk } from './clientsThunk';

export const getClients = createAsyncThunk(
	'clients/getClients',
	getClientsThunk,
);

const initialState: IState = { clients: [] };

const clientsSlice = createSlice({
	name: 'clientsSlice',
	initialState,
	reducers: { resetCarriers: () => initialState },
	extraReducers: builder => {
		builder.addCase(getClients.fulfilled, (state: IState, response: any) => {
			const { payload } = response;
			state.clients = payload.clients;
		});
	},
});

export default clientsSlice.reducer;
